import SvgIcon from '@/pages/home/components/SvgIcon';
import React, { useMemo } from 'react';
import GameSelector from '../../GameSelector';
import { connect, useDispatch, useIntl } from 'umi';
import RenderGameIcon from '../../RenderImg/renderGameIcon';
import { Popover } from 'tea-component';

function ChangeGameItem({
  showGameInfo,
  wholeGameInfo,
  changeGameVisible,
}: any) {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  const [gameInfo, gameName] = useMemo(() => {
    if (wholeGameInfo.cover) {
      return [wholeGameInfo, wholeGameInfo.entity_name];
    }
    if (showGameInfo.cover) {
      return [showGameInfo, showGameInfo.entity_name];
    }

    return [
      {},
      wholeGameInfo.entity_name || formatMessage({ id: '《Opinions Game》' }),
    ];
  }, [showGameInfo, wholeGameInfo, formatMessage]);

  return (
    <>
      <Popover
        placement="right-start"
        trigger="click"
        visible={changeGameVisible}
        onVisibleChange={(visible: boolean) => {
          dispatch({
            type: 'opinionCommon/save',
            payload: {
              changeGameVisible: visible,
            },
          });
        }}
        overlay={<GameSelector />}
      >
        <div className="navmenu-hd-info navmenu-hd-gameselector">
          {/* navmenu-hd-info-imgwidth 长图片的样式使用这个类名  navmenu-hd-info-img 短图片样式*/}

          <RenderGameIcon
            gameInfo={gameInfo}
            className="navmenu-hd-info-img"
          ></RenderGameIcon>

          <div className="navmenu-hd-info-title">
            <div className="wrapper-context">
              <div className="wrapper-context-bd">{gameName}</div>
            </div>
          </div>
          <div className="navmenu-hd-info-icon">
            <SvgIcon type="left-turn-right" />
          </div>
        </div>
      </Popover>

      {/*游戏选择弹出框*/}
      {/*用visible && 的方式是为了解决搜素后关闭弹窗，打开后仍然是搜素界面的问题 */}
    </>
  );
}

export default connect((state: any) => {
  const { opinionCommon } = state;

  return {
    wholeGameInfo: opinionCommon.wholeGameInfo || {},
    showGameInfo: opinionCommon.showGameInfo || {},
    changeGameVisible: opinionCommon.changeGameVisible,
  };
})(ChangeGameItem);
